import { computeTextBoxLayout } from "@vninvestcharts/engine-core";
function boxMarkers(pixel, boxWidth, bgHeight) {
    return [
        { point: { x: pixel.x, y: pixel.y }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x + boxWidth, y: pixel.y }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x, y: pixel.y + bgHeight }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x + boxWidth, y: pixel.y + bgHeight }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x + boxWidth / 2, y: pixel.y }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x + boxWidth, y: pixel.y + bgHeight / 2 }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x + boxWidth / 2, y: pixel.y + bgHeight }, radius: 4, color: "#2962ff", fill: "white" },
        { point: { x: pixel.x, y: pixel.y + bgHeight / 2 }, radius: 4, color: "#2962ff", fill: "white" },
    ];
}
export function buildTextPrimitive(drawing, scales, primitiveStyle, toPixel) {
    const [point] = drawing.points;
    if (!point)
        return null;
    const pixel = toPixel(point, scales);
    const fontSize = drawing.style?.fontSize ?? 12;
    const { boxWidth, bgHeight } = computeTextBoxLayout(drawing.text ?? "", drawing.style?.textBoxWidth, drawing.style?.textBoxHeight, fontSize);
    return {
        type: "text",
        points: [pixel],
        style: primitiveStyle,
        text: drawing.text,
        pointMarkers: boxMarkers(pixel, boxWidth, bgHeight),
    };
}
export function buildCalloutPrimitive(drawing, scales, primitiveStyle, toPixel) {
    const [boxAnchor, tailAnchor] = drawing.points;
    if (!boxAnchor || !tailAnchor)
        return null;
    const pixel = toPixel(boxAnchor, scales);
    const tailPixel = toPixel(tailAnchor, scales);
    const fontSize = drawing.style?.fontSize ?? 12;
    const { boxWidth, bgHeight } = computeTextBoxLayout(drawing.text ?? "", drawing.style?.textBoxWidth, drawing.style?.textBoxHeight, fontSize);
    return {
        type: "callout",
        points: [pixel, tailPixel],
        style: primitiveStyle,
        text: drawing.text,
        pointMarkers: [
            ...boxMarkers(pixel, boxWidth, bgHeight),
            { point: tailPixel, radius: 5, color: "#f59e0b", fill: "white" },
        ],
    };
}
export function buildPriceLabelPrimitive(drawing, scales, primitiveStyle, toPixel) {
    const [anchor] = drawing.points;
    if (!anchor)
        return null;
    const pixel = toPixel(anchor, scales);
    const fontSize = drawing.style?.fontSize ?? 12;
    const { boxWidth, bgHeight } = computeTextBoxLayout(drawing.text ?? "", drawing.style?.textBoxWidth, drawing.style?.textBoxHeight, fontSize);
    return {
        type: "priceLabel",
        points: [pixel],
        style: primitiveStyle,
        text: drawing.text,
        pointMarkers: boxMarkers(pixel, boxWidth, bgHeight),
    };
}
export function buildAnnotationPrimitive(drawing, scales, primitiveStyle, toPixel) {
    switch (drawing.type) {
        case "text":
            return buildTextPrimitive(drawing, scales, primitiveStyle, toPixel);
        case "callout":
            return buildCalloutPrimitive(drawing, scales, primitiveStyle, toPixel);
        case "priceLabel":
            return buildPriceLabelPrimitive(drawing, scales, primitiveStyle, toPixel);
        default:
            return null;
    }
}
